<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />

    <!--    보고자 정보-->
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i>{{ $t('보고자 정보') }}</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('발신') }}</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputB_1 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputB_1"
          class="w-full flex-1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('송화자') }}</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputB_2 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputB_2"
          class="w-full flex-1"
        />
      </div>
    </div>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('수신') }}</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputB_3 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputB_3"
          class="w-full flex-1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('수화자') }}</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputB_4 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputB_4"
          class="w-full flex-1"
        />
      </div>
    </div>

    <!--    내용-->
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i>{{ $t('내용') }}</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('재해일시') }}</div>
        <p v-if="isPrint" class=" print-input flex-1">
          {{ form.inputC_1 }}
        </p>
        <date-selector v-else :readonly="board.readonly" class="w-full flex-1" v-model="form.inputC_1" />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('재해시간') }}</div>
        <p v-if="isPrint" class=" print-input flex-1">
          {{ form.inputC_2 }}
        </p>
        <time-selector v-else class="w-full flex-1" v-model="form.inputC_2" :readonly="board.readonly"/>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('요일') }}</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputC_3 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputC_3"
          class="w-full flex-1"
        />
      </div>

      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('소속') }}</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputC_4 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputC_4"
          class="w-full flex-1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('성명') }}</div>
        <p  v-if="isPrint" class=" print-input flex-1">{{ name }}</p>
        <ml-input
          :readonly="board.readonly"
          v-else
          v-model="name"
          @focus="onNameFocus"
          @blur="onNameBlur"
          class="w-full flex-1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('직종') }}</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputC_6 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputC_6"
          class="w-full flex-1"
        />
      </div>

      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('일당') }}</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputC_7 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputC_7"
          class="w-full flex-1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('주민등록번호') }}</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputC_8 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputC_8"
          class="w-full flex-1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('생년월일') }}</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputC_9 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputC_9"
          class="w-full flex-1"
        />
      </div>

      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('나이') }}</div>
        <p class="mr-3">만</p>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputC_10 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputC_10"
          class="w-full flex-1"
        />
        <p class="ml-3">세</p>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('주소') }}</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputC_11 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputC_11"
          class="w-full flex-1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('채용년월일') }}</div>
        <p v-if="isPrint" class=" print-input flex-1">
          {{ form.inputC_12 }}
        </p>
        <date-selector v-else :readonly="board.readonly" class="w-full flex-1" v-model="form.inputC_12" />
      </div>

      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('치료기관') }}</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputC_13 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputC_13"
          class="w-full flex-1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('재해형태') }}</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputC_14 }}</p>
        <disaster-class-selector
          v-else
          class="w-full flex-1"
          :readonly="board.readonly"
          v-model="form.inputC_14"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('재해정도') }}</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputC_15 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputC_15"
          class="w-full flex-1"
        />
      </div>

      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('재산피해') }}</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputC_16 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputC_16"
          class="w-full flex-1"
        />
      </div>
    </div>

<!--    목격자 인적사항-->
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i>{{ $t('목격자 인적사항') }}</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('성명') }}</div>
        <p  v-if="isPrint" class=" print-input flex-1">{{ observerName }}</p>
        <ml-input
          :readonly="board.readonly"
          v-else
          v-model="observerName"
          @focus="onNameFocusObserver"
          @blur="onNameBlurObserver"
          class="w-full flex-1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('직종') }}</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputD_2 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputD_2"
          class="w-full flex-1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('주민등록번호') }}</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputD_3 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputD_3"
          class="w-full flex-1"
        />
      </div>

      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('주소') }}</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputD_4 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputD_4"
          class="w-full flex-1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('연락처') }}</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputD_5 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputD_5"
          class="w-full flex-1"
        />
      </div>
    </div>

    <div class="print-container mt-4">
      <vs-row class="mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i>{{ $t('재해 발생 상황') }}</h5>
        </vs-col>
      </vs-row>
      <p v-if="isPrint" class="print-textarea flex-1">{{ form.inputD_6 }}</p>
      <ml-textarea
        v-else
        class="flex-1 w-full"
        rows="5"
        v-model="form.inputD_6"
        :readonly="board.readonly"
        placeholder="입력필드"
      />
    </div>

<!--    사후처리-->
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i>{{ $t('사후처리') }}</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('초진 결과(예상)') }}</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputE_1 }}</p>
        <ml-input
          v-else-if="board.readonly"
          readonly
          v-model="form.inputE_1"
          class="w-full flex-1" />
        <vs-select
          :disabled="board.readonly"
          v-else
          v-model="form.inputE_1"
          autocomplete
          class="w-full flex-1"
        >
          <vs-select-item text="입원" value="입원" />
          <vs-select-item text="통원" value="통원" />
        </vs-select>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">{{ $t('상병명') }}</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputE_2 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputE_2"
          class="w-full flex-1"
        />
      </div>
    </div>

<!--    현장조치 결과 및 의견-->
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i>{{ $t('현장조치 결과 및 의견') }}</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 mt-4">
      <div class="print-container col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">{{ $t('조치결과') }}</div>
        <p v-if="isPrint" class="print-textarea">{{ form.inputF_1 }}</p>
        <ml-textarea
          :readonly="board.readonly"
          v-else
          v-model="form.inputF_1"
          class="flex-1 w-full"
          rows="5"
        />
      </div>
      <div class="print-container col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">{{ $t('의견') }}</div>
        <p v-if="isPrint" class="print-textarea">{{ form.inputF_2 }}</p>
        <ml-textarea
          :readonly="board.readonly"
          v-else
          v-model="form.inputF_2"
          class="flex-1 w-full"
          rows="5"
        />
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableDuration from "../../../../components/TableDuration";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import TableCustom from "@/components/TableCustom";
import TimeSelector from '@/components/selector/TimeSelector'

export default {
  components: {
    TimeSelector,
    TableCustom,
    DisasterClassSelector,
    TableDuration,
    FieldSelectModule,
    FileUploadModule,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        if (this.form.inputC_5 !== null && this.form.inputC_5 !== '') {
          this.name = this.form.inputC_5
          this.onNameBlur()
        }
        if (this.form.inputD_1 !== null && this.form.inputD_1 !== '') {
          this.observerName = this.form.inputD_1
          this.onNameBlurObserver()
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    onNameFocus () {
      this.name = this.form.inputC_5
    },
    onNameBlur () {
      this.form.inputC_5 = this.name
      const length = this.name.length
      if (2 < length) {
        const first = this.name[0]
        const last = this.name[this.name.length - 1]
        let star = ''
        for (let index = 0; index < length - 2; index++) {
          star += '*'
        }
        this.name = first + star + last
      } else if (length === 2) {
        const first = this.name[0]
        this.name = `${first  }*`
      }
    },
    onNameFocusObserver () {
      this.observerName = this.form.inputD_1
    },
    onNameBlurObserver () {
      this.form.inputD_1 = this.observerName
      const length = this.observerName.length
      if (2 < length) {
        const first = this.observerName[0]
        const last = this.observerName[this.observerName.length - 1]
        let star = ''
        for (let index = 0; index < length - 2; index++) {
          star += '*'
        }
        this.observerName = first + star + last
      } else if (length === 2) {
        const first = this.observerName[0]
        this.observerName = `${first  }*`
      }
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",

        inputC_1: "",
        inputC_2: "",
        inputC_3: "",
        inputC_4: "",
        inputC_5: "",
        inputC_6: "",
        inputC_7: "",
        inputC_8: "",
        inputC_9: "",
        inputC_10: "",
        inputC_11: "",
        inputC_12: "",
        inputC_13: "",
        inputC_14: "",
        inputC_15: "",
        inputC_16: "",

        inputD_1: "",
        inputD_2: "",
        inputD_3: "",
        inputD_4: "",
        inputD_5: "",
        inputD_6: "",

        inputE_1: "",
        inputE_2: "",

        inputF_1: "",
        inputF_2: "",

        fileList: [],
      },
      name: '',
      observerName: '',
    };
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$w-inpu0: 260px;
$w-inpu1: 220px;
$w-inpu2: 140px;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-1 {
  background-color: #f9f9f9;
  border-bottom: $border;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 12px;
}

.mt-component-form {
  margin-top: 15px;
}

.text-box {
  line-height: 19px;
  margin-top: 15px;
  border: $border;
}

/* uploaded File */
.form-group {
  border: $border;
  overflow: auto;
  width: 100%;
  /*overflow-x: auto;*/

  &__header {
    height: 80px;
    width: 100%;
    display: flex;

    &-title {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-title.title-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }
  }

  &__content {
    width: 100%;
    display: flex;

    &-row {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      padding: 7px;
    }

    &-row.row-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }

    &-row.row-w2 {
      min-width: $w-inpu1;
    }
  }
}

.row-w1 {
  min-width: $w-inpu1;
}

.row-w0 {
  min-width: $w-inpu0;
}

.bx {
  border-left: $border;
  border-right: $border;
}

.br {
  border-right: $border;
}

.bb {
  border-bottom: $border;
}
</style>
